export { AnatomoService } from './anatomo/anatomo.service';
export { ObjectoService } from './objecto/objecto.service';
